import type { Node as PMNode } from "@tiptap/pm/model"
import { asAttachmentId, asStandardId, type AttachmentId, type StandardId } from "./types"

function stringAttr(value: unknown): string | null {
  return typeof value === "string" && value.length > 0 ? value : null
}

/**
 * The attachment a link token points at. Null for a token carrying no `attachmentId` — legacy
 * markup predating the attribute — which has no attachment for an event to name.
 */
export function attachmentIdOfNode(node: PMNode): AttachmentId | null {
  const id = stringAttr(node.attrs.attachmentId)
  return id ? asAttachmentId(id) : null
}

export function standardIdOfNode(node: PMNode): StandardId | null {
  const standard: unknown = node.attrs.standard
  const id =
    standard && typeof standard === "object" && "id" in standard ? stringAttr(standard.id) : null
  return id ? asStandardId(id) : null
}
